// The cloud fitness_app_id of the host Wahoo App, as `useConfigContext().fitnessAppId` reports it.
export const WAHOO_APP_IOS_FITNESS_APP_ID = 30;
export const WAHOO_APP_ANDROID_FITNESS_APP_ID = 31;
